import React, { useState } from "react";

import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { userResetPasswordApi } from "../../../Services/Login/LoginApi/loginApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import axios from "axios";


function PasswordChange() {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [oldPassword, setOldPassword] = useState("");
  const queryParams = new URLSearchParams(window.location.search);
  // console.log('QuertParams----',queryParams);
  
  const userEmail = queryParams.get("email"); // Get the email from query params
  // console.log('userEmail----',userEmail);

  const userId =localStorage.getItem('user_id')


  const validateForm = () => {
    const validationErrors = {};
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        showNewPassword
      ) &&
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        showConfirmPassword
      )
    ) {
      validationErrors.showNewPassword =
        "Password must contain at least 8 characters, including uppercase, lowercase, numerals, and symbols.";
    }
    if (showNewPassword !== showConfirmPassword) {
      validationErrors.showConfirmPassword = "Passwords do not match.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };


// Function to fetch user details
// async function getUserDetails(userId) {
//   try {
    
//     const response = await fetch(`http://sdeiaiml.com:9034/auth/provider/${userId}`); // Replace with your API endpoint
//     if (!response.ok) throw new Error('Failed to fetch user details');
//     return await response.json(); // Assuming the API returns { id, email, name, ... }
//   } catch (error) {
//     console.error('Error fetching user details:', error);
//     return null;
//   }
// }
async function getUserDetails(userId) {

  try {
    const token = localStorage.getItem("accessToken"); // Assuming token is stored in localStorage
    

    // if (!token) {
    //   console.error("Authorization token not found!");
    //   return null;
    // }
   
    try {
     const res= await axios.get(`http://sdeiaiml.com:9034/auth/provider/${userId}`,{
      // const res= await axios.get(`http://0.0.0.0:8003/auth/provider/${userId}`,{
      headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Passing token here
          }
        },)
  
    return res.data;
      
    } catch (error) {
      
    }

    // const response = await fetch(`http://0.0.0.0:8003/auth/provider/${userId}`, {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${token}`, // Passing token here
    //   },
    // });

    // console.log(
    //   response,
    //   `Fetching from: http://sdeiaiml.com:9034/auth/provider/${userId}`
    // );

    // if (!response.ok) throw new Error("Failed to fetch user details");

    // return await response.json();
  } catch (error) {
    console.error("Error fetching user details:", error);
    return null;
  }
}
  

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    Object.values(errors).forEach((error) => {
      toast.error(error);
    });
    return;
  }

  try {
    const userDetails = await getUserDetails(userId);
  
    const result = await dispatch(
      userResetPasswordApi({
        email: userDetails.data.email,
        old_password: oldPassword,
        new_password: showNewPassword,
      })
    );

    if (userResetPasswordApi.fulfilled.match(result)) {
      toast.success("Password Reset Successfully", {
        onClose: () => navigate(-1),
      });
    } else {
      toast.error(result.payload?.message || "Password Reset failed! Try Again");
    }
  } catch (error) {
    console.error("Password Reset error: ", error);
    toast.error("An unexpected error occurred. Please try again.");
  }
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) {
  //     Object.values(errors).forEach((error) => {
  //       toast.error(error);
  //     });
  //     return;
  //   }

  //   try {
  //     const result = await dispatch(
  //       userResetPasswordApi({
  //         email: userEmail,
  //         new_password: showNewPassword,
  //       })
  //     );
  //     if (userResetPasswordApi.fulfilled.match(result)) {
  //       toast.success("Password Reset Successfully", {
  //         onClose: () => navigate("/password-success"),
  //       });
  //     } else {
  //       toast.error("Password Reset failed ! Try Again");
  //     }
  //   } catch (error) {
  //     console.error("Password Reset fetching error ", error);
  //   }
  // };

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one setpw-page ">
        <div className="container-fluid p-0 m-0">
        <div className="row m-0 loginpage" style={{ justifyContent: "center" }}>
            {/* <div className="col-md-6">
              <div className="login-right-block logo-left-block mb-0">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
                <div className="back-btn set-pw">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image">
         
                  <div className="text-overlay">
                  <h5>Welcome Back!</h5>
                  <p>
                    Elevate your business insights with precision. Log in to
                    discover and refine your Ideal Customer Profiles
                    effortlessly.
                  </p>
                </div>
                </div>
               
              </div>
            </div> */}
            <div className="col-md-10 login-cols-block change-pw">
              {/* <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
                <div className="back-btn set-pw">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div> */}
              <div className="login-page-area setpw-area">
                <div className="login-information log-in">
                  <h1 className="text-center mt-4"></h1>
                  {/* <p className="pw-texts text-center">
                    Your new password must be different to previously used
                    passwords.
                  </p> */}
                  <div className="form-login text-left">
                  
                    <div className="mb-4">
                      <InputLabel htmlFor="confirm-password">
                        Current Password <span>*</span>
                      </InputLabel>
                      <Input
                      className="password-input-box"
                      id="old-password"
                      placeholder="Current Password"
                      type={showConfirmPassword ? "text" : "password"}
                      value={oldPassword} //  Bind state
                      onChange={(event) => setOldPassword(event.target.value)} // Update state
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showConfirmPassword
                                ? "hide the password"
                                : "display the password"
                            }
                            onClick={() =>
                              setShowConfirmPassword((prev) => !prev)
                            }
                            onMouseDown={(event) => event.preventDefault()}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="new-password">
                       New Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="new-password"
                        placeholder="New Password"
                        type={showNewPassword ? "text" : "password"}
                        onChange={(event) =>
                          setShowNewPassword(event.target.value)
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showNewPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      <div className="pw-text-bottom">
                        {/* Password should be the combination of{" "} */}
                        <span>
                          {/* Uppercase & Lowercase Letters, Numerals and Symbols */}
                        </span>
                        
                      </div>
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="confirm-password">
                        Confirm Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="confirm-password"
                        placeholder="Confirm Password"
                        type={showConfirmPassword ? "text" : "password"}
                        onChange={(event) =>
                          setShowConfirmPassword(event.target.value)
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showConfirmPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Change Password</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      {/* <p>
                        Need Help? <a href="">Click Here</a>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default PasswordChange;
